.#{$namespace}-svg {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 1em;
	height: 1em;
	color: inherit;
	fill: currentColor;
	line-height: 1;
	flex-shrink: 0;

	svg {
		display: block;
		width: 1em;
		height: 1em;
		fill: currentColor;
	}
}
